import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze švadlenek — zrcadlo Tabidoo tabulky „databazeSvadlenek". */
export function DatabazeSvadlenekPage() {
  return (
    <TabidooTablePage
      table="svadlenky"
      storagePrefix="svadlenky"
      title="Databáze švadlenek"
      subtitle="Zrcadlo z Tabidoo. Hledej globálně, filtruj po sloupcích, přehazuj sloupce tažením. Klikni na řádek pro detail a editaci."
      createLabel="Nová švadlenka"
    />
  );
}
